import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Trash",
  "use": "Trash-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Trash\"><path fill-rule=\"evenodd\" d=\"M19.875 58h24.363l.362-6.923L46.41 18.4H17.702l1.81 32.677.363 6.923zM15 58.55L12.802 18.4H7V12h20V6.4h10V12h20v6.4h-5.69L49 60.6V63H15v-4.45zM29.5 25.5v30h-5v-30h5zm10 0v30h-5v-30h5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol